import React from 'react';
import cx from 'classnames';

import styles from './Flags.module.scss';

export interface Props {
  className?: Parameters<typeof cx>[0];
}

export const CA: React.FC<Props> = ({ className }) => (
  <i className={cx(styles.icon, className)}>
    <svg width={25} height={24} fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g>
        <path d='M24.5 4H.5v15.998h24V4z' fill='#fff' />
        <path
          d='M8.502 4H.5v15.998h8.002V4zM24.5 4h-8.002v15.998H24.5V4zM14 13.113l1.5-.75-.75-.375v-.75l-1.5.75.75-1.5h-.75l-.75-1.125-.75 1.125H11l.75 1.5-1.5-.75v.75l-.75.375 1.5.75-.375.75h1.5v1.125h.75v-1.125h1.5l-.375-.75z'
          fill='#D80027'
        />
      </g>
      <path d='M.5 4h24v15.998H.5z' stroke='#111' />
    </svg>
  </i>
);

CA.displayName = 'CA';
export default CA;
